
import { i18nText } from '@/locales';

import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {Chart, ChartOptions} from 'chart.js';

@Component({})
export default class PieChartComponent extends Vue {
  @Prop() index!: string | number;
  @Prop() data!: Record<string, any>;

  chartType = 'pie';
  chartLabels: any = [];
  valueData: any = [];
  chartName = 'pie_chart_';

  created(): void {
    this.chartName = this.chartName + this.index;
    if (this.data) {
      Object.keys(this.data).map((objectKey, index) => {
        const value = this.data[objectKey];
        this.chartLabels.push(objectKey + ' (%)');
        this.valueData.push(value);
      });
    }
  }

  mounted(): void {
    const ctx = <HTMLCanvasElement>document.getElementById(this.chartName);
    if(ctx) {
      const canvas = <string | HTMLCanvasElement | CanvasRenderingContext2D | ArrayLike<HTMLCanvasElement | CanvasRenderingContext2D> | any>ctx.getContext('2d');
      let tooltipEl = document.querySelector(`#${this.chartName}-tooltip`) as HTMLElement;

      const self = this;
      new Chart(canvas, {
        type: this.chartType,
        data: {
          labels: this.chartLabels,
          datasets: [{
            label: i18nText("Доходы"),
            data: this.valueData,
            backgroundColor: ['rgb(250,120,117)', 'rgb(211,242,97)', 'rgb(105,192,255)', 'rgb(255,192,105)'],
          }
          ]
        },
        options: {
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
            position: 'nearest',
            custom: function(tooltipModel) {

              // Create element on first render
              if (!tooltipEl) {
                  tooltipEl = document.createElement('div');
                  tooltipEl.innerHTML = '<table></table>';
                  document.body.appendChild(tooltipEl);
              }

              if (tooltipEl) {
                document.querySelector(`#${self.chartName}-parent-div`)?.addEventListener("mouseover", (e: Event) => {
                  tooltipEl.style!.visibility = 'visible';
                });
                document.querySelector(`#${self.chartName}-parent-div`)?.addEventListener("mouseleave", (e: Event) => {
                  tooltipEl.style!.visibility = 'hidden';
                });
              }

              function getBody(bodyItem: any) {
                  return bodyItem.lines[0];
              }

              if (tooltipModel.body) {
                const titleLines = tooltipModel.title || [];
                const bodyLines = tooltipModel.body.map(getBody);

                let innerHtml = '<thead>';
                titleLines.forEach(function(title) {
                    innerHtml += '<tr><th>' + title + '</th></tr>';
                });
                innerHtml += '</thead><tbody>';

                bodyLines.forEach(function(body, i) {
                    const colors = tooltipModel.labelColors[i];
                    // let style = 'background:' + colors.backgroundColor;
                    let style = ' border-color:' + colors.borderColor;
                    style += '; border-width: 2px';
                    const span = '<span style="' + style + '">' + body + '</span>';
                    innerHtml += '<tr><td>' + span + '</td></tr>';
                });
                innerHtml += '</tbody>';

                let tableRoot = tooltipEl.querySelector('table') as HTMLElement;

                tableRoot.innerHTML = innerHtml;
              }

              if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
              } else {
                  tooltipEl.classList.add('no-transform');
              }
              const {offsetLeft: positionX, offsetTop: positionY} = canvas.canvas;
              
              // const position = canvas.canvas.getBoundingClientRect();
              tooltipEl.style.opacity = '1';
              tooltipEl.style.left = positionX + tooltipModel.caretX + 'px';
              tooltipEl.style.top = positionY + tooltipModel.caretY + 'px';
              tooltipEl.style.font = tooltipModel._bodyFontFamily;
              tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
            }
          }
        }
      });
    }
  }
}
